import React from "react";
import { IPlan } from "../../types/subscription";
import "./Plan.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

interface PlanProps {
  subscription: Partial<IPlan>;
  full: boolean;
}

export const Plan = ({ subscription, full }: PlanProps) => {
  const url = full
    ? `/subscription/${subscription.id}`
    : `${process.env.REACT_APP_URL_CHECKOUT}${subscription.plan_id}`;
  const renderCommonContent = () => {
    return (
      <>
        <h1>
          <strong>{subscription.name}</strong>
        </h1>
        <p style={{ marginInline: "20px" }}>
          {"(" + subscription.plans_description?.details + ")"}
        </p>
        <div>SmartWatch:</div>
        <div style={{ fontWeight: "600", marginBottom: "20px" }}>
          <sub>
            {subscription.plans_description?.watch_price === 0
              ? "En Comodato ($0)"
              : `$ ${subscription.plans_description?.watch_price?.toLocaleString(
                  "es-ES"
                )}`}
          </sub>
        </div>
        <div>Costo de instalación:</div>
        <div style={{ fontWeight: "600", marginBottom: "20px" }}>
          {/* <sub>{subscription.plans_description?.permanence_time}</sub> */}
          <sub>
            $
            {parseFloat(
              subscription.plans_description?.setup_price || "0"
            ).toLocaleString("es-ES")}
          </sub>
        </div>
        <h1>
          <b>
            ${" "}
            {subscription.plans_description?.plan_price &&
              parseFloat(
                subscription.plans_description?.plan_price || "0"
              ).toLocaleString("es-ES")}
          </b>
          /mes
        </h1>
        <sub>Pesos Argentinos</sub>
        <br />
      </>
    );
  };
  return (
    <div className="plan-container">
      {renderCommonContent()}
      <Link to={url}>
        <Button
          size="large"
          sx={{
            backgroundColor: "#0066FF",
            color: "#FFFFFF",
            fontFamily: "Quicksand",
            textTransform: "none",
            width: "150px",
            margin: "15px 0px 20px",
            "&:hover": { backgroundColor: "#0066FF", color: "#FFFFFF" },
          }}
        >
          {full ? "Más Información" : "Contratar"}
        </Button>
      </Link>
      {full && (
        <Link
          to={`${process.env.REACT_APP_URL_CHECKOUT}${subscription.plan_id}`}
        >
          <Button
            size="large"
            sx={{
              backgroundColor: "#427E46",
              color: "#FFFFFF",
              fontFamily: "Quicksand",
              textTransform: "none",
              width: "150px",
              margin: "15px 0px 20px",
              "&:hover": { backgroundColor: "#427E46", color: "#FFFFFF" },
            }}
          >
            Contratar
          </Button>
        </Link>
      )}
      {/* <a
        href={
          subscription.subscription_type === SubscriptionType.GOLD
            ? "/PlanGold"
            : "/PlanGoldComodato"
        }
        style={{
          width: "150px",
          padding: "7px",
          backgroundColor: "#0066FF",
          color: "#FFFFFF",
          textAlign: "center",
          borderRadius: "5px",
          textDecoration: "none",
          margin: "15px 0px 20px",
        }}
      >
        {full ? "Más Información" : "Contratar"}
      </a> */}

      {full && (
        <React.Fragment>
          <hr
            style={{
              width: "90%",
              borderWidth: "2px",
              borderColor: "#0066FF",
              zIndex: "1",
              marginBottom: "25px",
            }}
          />
          <div>
            <div style={{ color: "#0066FF", fontWeight: "600" }}>
              Dispositivos
            </div>
            <div style={{ marginBottom: "20px" }}>
              {subscription.plans_description?.devices?.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </div>
            <div style={{ color: "#0066FF", fontWeight: "600" }}>Funciones</div>
            <div style={{ marginBottom: "20px" }}>
              {subscription.plans_description?.functions?.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </div>
            <div style={{ color: "#0066FF", fontWeight: "600" }}>
              Red de Ayuda
            </div>
            <div style={{ marginBottom: "20px" }}>
              <div>
                {subscription.plans_description?.quantity_companions &&
                  subscription.plans_description.quantity_companions}{" "}
                persona
                {subscription.plans_description?.quantity_companions &&
                subscription.plans_description?.quantity_companions > 1
                  ? "s"
                  : ""}
              </div>
              <div>Ellie Center 24x7</div>
            </div>
            <div style={{ color: "#0066FF", fontWeight: "600" }}>
              Beneficios
            </div>
            <div style={{ marginBottom: "20px" }}>
              {subscription.plans_description?.benefits?.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </div>
            <div style={{ color: "#0066FF", fontWeight: "600" }}>Mente</div>
            <div style={{ marginBottom: "20px" }}>
              {subscription.plans_description?.mind?.map((item, index) => (
                <div key={index}>{item}</div>
              ))}{" "}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default Plan;
